import React from 'react';
import { elements } from '@ecosystem/newron-design-system';

import './SortIcon.css';

type SortIconsProps = {
  direction?: 'asc' | 'desc';
};

function SortIcon({ direction }: SortIconsProps) {
  const { Icon } = elements;
  return (
    <div data-test-id="sort-icon">
      <Icon color={direction === 'asc' ? 'default' : 'light'} testId="arrow-drop-up">
        <Icon.icons.ArrowDropUp />
      </Icon>
      <div className="sort-icon-margin">
        <Icon color={direction === 'desc' ? 'default' : 'light'} testId="arrow-drop-down">
          <Icon.icons.ArrowDropDown />
        </Icon>
      </div>
    </div>
  );
}

export { SortIcon };
